/* eslint-disable react/jsx-boolean-value */
import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Box, Container, Grid, Typography } from '@mui/material';
// components
import ReactPlayer from 'react-player'
import Image from '../../components/Image';
import { MotionContainer, MotionInView, TextAnimate, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  padding: theme.spacing(0, 0),
  [theme.breakpoints.up('md')]: {
    padding: 0,
  },
}));

const VideoStyle = styled(Box)(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));

const ImageStyle = styled(Box)(({ theme }) => ({
  width: '50%',
  [theme.breakpoints.up('md')]: {
    width: '50%',
  },
}));


// ----------------------------------------------------------------------

export default function VideoImage({block}) {
  return (
    <RootStyle>
         <Container sx={{ justifyContent: 'center' }}>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12} md={5} sx={{ justifyContent: 'center' }}>
            <MotionInView variants={varFade().inRight}>
              <Image
                src={block.backgroundImg}
                justifyContent="center"
                sx={{ borderRadius: 2 }}
              />
            </MotionInView>
          </Grid>
        </Grid>
      </Container>
    </RootStyle>
  );
}
